import { FC } from 'react';
import { BeatLoader } from 'react-spinners';
import { strings } from '@/constants/strings';
import { Response } from '@/types/wellbeing-response';
import { ResponseListItem } from './response-list-item';

export type ResponseListProps = {
  responses: Response[];
  loading?: boolean;
};

export const ResponseList: FC<ResponseListProps> = ({ responses, loading }) => (
  <div className="flex max-w-[30rem] flex-col px-6">
    {loading ? (
      <BeatLoader />
    ) : responses.length > 0 ? (
      responses.map((response, index) => (
        <ResponseListItem
          isLast={index === responses.length - 1}
          key={index}
          response={response}
        />
      ))
    ) : (
      <div className="text-xs italic text-gray-500">
        {strings.wellbeing_responses.empty}
      </div>
    )}
  </div>
);
